<div>
	<div class="modal-header">
		<h4 class="modal-title">Télécharger des fichiers</h4>
		<button type="button" class="close" aria-label="Close" (click)="cancelDialog()"><span aria-hidden="true">&times;</span></button>
	</div>

	<div class="modal-body">
		<app-alert-line [alertLineData]="alertLine"></app-alert-line>
		<div class="form-group">
			<p>
			Sélectionnez le ou les fichiers que vous souhaitez nous envoyer. Une fois votre liste de fichier complète,
			cliquez sur le bouton "Déposer".<br>
			<br>
			Utilisez le bouton "Vider" pour réinitialiser la liste des fichiers à envoyer.
			</p>
		</div>

		<div class="form-group">
			<p-fileUpload
				name="fileupload"
				[multiple]="true"
				[maxFileSize]="100000000"
				[fileLimit]="20"
				[url]="urlServer"

				chooseLabel="Sélectionner"
				uploadLabel="Déposer"
				cancelLabel="Vider"

				invalidFileSizeMessageSummary="{0}: Fichier trop gros (Maximum 100 Mo),"
				invalidFileSizeMessageDetail="La taille maximum est de 100 Mo."
				invalidFileLimitMessageDetail="Nombre de fichier maximum est {0},"
				invalidFileLimitMessageSummary="Nombre de fichier maximum dépassé."

				[headers]="httpHeaders"

				(onUpload)="onUpload($event)"
				(onError)="onError($event)">
				<!-- <ng-template pTemplate="content">
					<ul *ngIf="uploadedFiles.length">
						<li *ngFor="let file of uploadedFiles">
							{{file.name}} - {{file.size}} bytes
						</li>
					</ul>
				</ng-template> -->
			</p-fileUpload>
		</div>
	</div>

	<div class="modal-footer">
		<button type="button" class="btn btn-light" (click)="cancelDialog()">Fermer</button>
	</div>
</div>